const https = require('https');
export const state = () => ({
  host: process.env.apiUrl,
  peoples: {
     loaded: false,
     items: [],
  },
  people: {
    loaded: false,
    item: [],
  },
  docs: {
    loaded: false,
    items: [],
  },
  doc: {
    loaded: false,
    item: [],
  },
  about: {
    loaded: false,
    item: [],
  }

})

export const mutations = {
  setPeopleList(state, payLoad) {
    const items = [];
    if(payLoad) {
        payLoad.forEach(item => {
          items.push({
            id: item.id,
            title: item.title,
            image: process.env.base + item.image || null,
            post: item.position,
            department: item.department,
          });
        });
    }
    state.peoples.items = items
    state.peoples.loaded = true
  },

  setPeopleOne(state, payLoad) {
    state.people.item =  {
       id: payLoad.id,
       title: payLoad.title,
       position:  payLoad.position,
       image:  process.env.base + payLoad.image || null,
       description: payLoad.description
    }
    state.people.loaded = true
  },

  setDocsList(state, payLoad) {
    state.docs.items = payLoad
    state.docs.loaded = true
  },

  setDocsOne(state, payLoad) {

    const items = [];

    if(payLoad) {
        payLoad.forEach(item => {
          items.push({
            id: item.id,
            title: item.title,
            subsection_id: item.subsection_id,
            old_id: item.old_id,
            file: item.file ? process.env.base + item.file : null,
          });
        });
    }
    state.doc.item = items
    state.doc.loaded = true
  },

  setAboutOne(state, payLoad) {
    state.about.item = payLoad
    state.about.loaded = true
  },

}
export const actions = {

   // Получение спискок команды
    async peopleList({commit,dispatch,state}) {

      return  await this.$axios.$get(`${state.host}/methods/people/get_list/`).then(
        (response) => {
          commit('setPeopleList', response)
          return true;
        },
        (error) => {
          dispatch('showRequestError', error, { root: true });
          return false;
        }
      );
  },

  // Получение конкретного персона;
  async peopleOne({commit,dispatch,state},id) {
    try {

      const response = await this.$axios.$get(`${state.host}/methods/people/get_item/?id=${id}`)
      commit('setPeopleOne', response)
      return  response
    } catch (e) {
      dispatch('showRequestError', error, { root: true });
      throw e
    }
  },

  // Получение список документы
  async docsList({commit,dispatch,state}) {
    try {
      const response = await this.$axios.$get(`${state.host}/methods/docs/get_cats/`)
      commit('setDocsList', response)
      return  response
    } catch (e) {
      dispatch('showRequestError', error, { root: true });
      throw e
    }
  },
  // Получить конкретный документ
  async docsOne({commit,dispatch,state},cid) {
    try {
      const response = await this.$axios.$get(`${state.host}/methods/docs/get_list/?cid=${cid}/`)
      commit('setDocsOne', response)
      return  response
    } catch (e) {
      dispatch('showRequestError', error, { root: true });
      throw e
    }
  },

  // Получение контент о компании;
  async aboutOne({commit,dispatch,state}) {
    try {
      const response = await this.$axios.$get(`${state.host}/methods/news/get_title/?sid=company`)
      commit('setAboutOne', response)
      return  response
    } catch (e) {
     // dispatch('showRequestError', error, { root: true });
      throw e
    }
  },

}

export const getters = {

   peopleList (state) {
      return state.peoples
   },
   peopleOne (state) {
      return state.people
   },

   docsList (state) {
     return state.docs
   },

   docsOne (state) {
     console.log('docsOne',state.doc)
     return state.doc
   },
   aboutOne (state) {
     return state.about
   },
}



// WEBPACK FOOTER //
// ./store/company.js